export const DEADLINE_PROGRESS = {
  COMPLETE: 'COMPLETE',
  OVERDUE: 'OVERDUE',
  UPCOMING: 'UPCOMING',
  SUBMITTED_BUT_NOT_GRADED: 'SUBMITTED_BUT_NOT_GRADED',
} as const;

/**
 * List of type names that are considered real-world examples injectable
 * activities. The `-control` is intentionally excluded as this activity type
 * will never show up in the course outline, it's purpose is to signal for
 * "control" impression point.
 */
export const REAL_WORLD_EXAMPLE_TYPE_NAMES = ['practice-moment-static', 'practice-moment-interactive'];
